import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Switch, Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import AuthCheck from '../../../../common/components/AuthenticationCheck';
import withQuery from '../../../../common/components/withQuery';
import { getCurrentUser } from '../../../../redux-modules/current-user';
import CustomerActions from '../../actions/customers';
import OrganizationActions from '../../actions/organizations';
import { getCustomer } from '../../selectors/customers';
import { getOrganization } from '../../selectors/organizations';
import ActionHandler from '../ActionHandler';
import AuthRoute from '../AuthRoute';
import LoginRedirect from '../LoginRedirect';
import DetailPage from './DetailPage';
import ListPage from './ListPage';
import SurveyCompleted from './SurveyCompleted';

const NotFoundRedirect = ({ message }) => (
  <LoginRedirect
    returnUrl={window.location.href}
    message={
      message ||
      "We're sorry. We cannot find your account. Please contact NFIB Customer Care at 1-800-NFIB-NOW (1-800-634-2669)."
    }
  />
);

class SurveyLandingPage extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      path: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
    }),
    currentUser: PropTypes.object,
    currentCustomer: PropTypes.object,
    currentOrganization: PropTypes.object,
    actions: PropTypes.shape({
      customer: PropTypes.objectOf(PropTypes.func),
      organization: PropTypes.objectOf(PropTypes.func),
    }),
  };

  handleOrgResult = (success, message) => orgResult => {
    if (
      orgResult &&
      !success &&
      orgResult.hasError &&
      orgResult.status === 404
    ) {
      // if not logged in, and org id is not found go to login
      return <NotFoundRedirect message={message} />;
    }
    return null;
  };

  handleCustomerResult = (success, message) => custResult => {
    const { actions } = this.props;
    if (
      custResult &&
      !success &&
      custResult.hasError &&
      custResult.status === 404
    ) {
      // if not logged in, and customer id is not found go to login
      return <NotFoundRedirect message={message} />;
    }

    if (custResult && !custResult.hasError) {
      const { payload: { json: customer } } = custResult;
      const { key } = customer.organization || {};

      return (
        <ActionHandler
          condition={!!key}
          action={actions.organization.get}
          data={[key]}
          name="survey-get-org"
        >
          {this.handleOrgResult(success, message)}
        </ActionHandler>
      );
    }

    return null;
  };

  render() {
    const { actions, ...restProps } = this.props;

    const {
      currentCustomer,
      currentUser: { id: userId } = {},
      location: { query: { cst } },
    } = restProps;

    return (
      <div>
        <AuthCheck>
          {({ success, message }) => {
            return (
              <ActionHandler
                action={actions.customer.get}
                condition={!currentCustomer && (!!userId || !!cst)}
                data={[userId ? userId : cst]}
                name="survey-get-customer"
              >
                {this.handleCustomerResult(success, message)}
              </ActionHandler>
            );
          }}
        </AuthCheck>
        <Switch>
          <Route
            path={`${this.props.match
              .path}/:id([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/thank-you`}
            component={SurveyCompleted}
          />
          <Route
            path={`${this.props.match
              .path}/:id([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})`}
            render={matchProps => <DetailPage {...restProps} {...matchProps} />}
          />
          <AuthRoute
            render={matchProps => <ListPage {...restProps} {...matchProps} />}
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { location: { query: { cst } = {} } } = ownProps;
  const currentUser = getCurrentUser(state);

  const currentCustomer = getCustomer(state, {
    id: currentUser.id ? currentUser.id : cst,
  });

  let currentOrganization;
  if (
    currentCustomer &&
    currentCustomer.organization &&
    currentCustomer.organization.key
  ) {
    currentOrganization = getOrganization(state, {
      id: currentCustomer.organization.key,
    });
  }

  return {
    currentUser,
    currentCustomer,
    currentOrganization,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      customer: bindActionCreators(CustomerActions, dispatch),
      organization: bindActionCreators(OrganizationActions, dispatch),
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withQuery(SurveyLandingPage))
);



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/index.js